import {
    CouplePatientAPI,
    GroupPatientAPI,
    listAllTherapistPatientsResponse,
    type CouplePatient,
    type GroupPatient,
} from "../../patient";

/**
 * Everyone a meditation can be shared with: the therapist's patients (first
 * 200), couples and groups. Only a failing patient list rejects.
 */
export async function loadMeditationRecipientCaseload(therapistId: string) {
    const [patientsRes, couplesRes, groupsRes] = await Promise.all([
        listAllTherapistPatientsResponse(therapistId),
        // Couples and groups are a convenience: without them, patients one
        // by one still work.
        CouplePatientAPI.listByTherapist(therapistId).catch(() => ({
            data: [] as CouplePatient[],
        })),
        GroupPatientAPI.list().catch(() => ({ data: [] as GroupPatient[] })),
    ]);
    return { patients: patientsRes.data.patients, couples: couplesRes.data, groups: groupsRes.data };
}
